import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgStep3 = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    ref={svgRef}
    {...props}
  >
    <circle cx={16} cy={16} r={15} stroke="#DFE1E6" strokeWidth={2} />
    <path
      fill="currentColor"
      d="M15.876 21.792c-1.365 0-2.4-.32-3.104-.96-.704-.65-1.056-1.541-1.056-2.672h2.4c0 .544.139.95.416 1.216.288.267.736.4 1.344.4.587 0 1.024-.128 1.312-.384.299-.267.448-.64.448-1.12 0-1.003-.586-1.504-1.76-1.504h-1.04v-1.856h1.04c.512 0 .907-.107 1.184-.32.278-.213.416-.544.416-.992 0-.405-.133-.736-.4-.992-.266-.256-.666-.384-1.2-.384-.544 0-.949.128-1.216.384-.256.245-.384.603-.384 1.072h-2.4c0-1.099.331-1.952.992-2.56.672-.608 1.675-.912 3.008-.912.672 0 1.259.08 1.76.24.502.15.918.363 1.248.64.331.267.576.587.736.96.171.373.256.779.256 1.216 0 .619-.176 1.147-.528 1.584-.341.427-.8.73-1.376.912.662.181 1.168.496 1.52.944.363.448.544 1.04.544 1.776 0 .48-.096.923-.288 1.328a3.05 3.05 0 01-.832 1.056c-.352.288-.789.517-1.312.688-.512.16-1.088.24-1.728.24z"
    />
  </svg>
));
SvgStep3.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStep3;
